import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    background: theme.colors.Background3,
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    gap: theme.spacing.space8,
    padding: theme.spacing.space12,
    zIndex: theme.zIndex.normal,
    boxSizing: "border-box",
    borderRadius: theme.radius.medium,
    width: "100%",
    maxHeight: "30vh",
    scrollPaddingBottom: `${theme.spacing.space16}px`,
    scrollPaddingTop: `${theme.spacing.space16}px`,
    [BreakPointMobile]: {
      padding: theme.spacing.space8,
    },
  },
  option: {
    width: "100%",
    display: "flex",
    background: theme.colors.Background3,
    padding: theme.spacing.space12,
    borderRadius: theme.radius.small,
    border: "1.5px solid transparent",
    cursor: "pointer",
    [BreakPointDesktop]: {
      "&:hover": {
        background: theme.colors.Background4,
      },
    },
    boxSizing: "border-box",
  },
  selected: {
    background: theme.colors.Background4,
    width: "100%",
    padding: theme.spacing.space12,
    border: `1.5px solid ${theme.colors.Border4}`,
  },
}));
